module.exports = __webpack_public_path__ + "static/media/7.dd125091.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/7.png
// module id = 922
// module chunks = 0